export enum EBeforeWinAnimationEvents {
    BEFORE_WIN_ANIMATION_IN = 'BEFORE_WIN_ANIMATION_IN',
    BEFORE_WIN_ANIMATION_LOOP = 'BEFORE_WIN_ANIMATION_LOOP',
    BEFORE_WIN_ANIMATION_OUT = 'BEFORE_WIN_ANIMATION_OUT'
}
